var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.utcMoment.format()),expression:"utcMoment.format()"}]},[_vm._v(_vm._s(_vm.localDateStr))])
}
var staticRenderFns = []

export { render, staticRenderFns }